var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5299 6.90005L11.9699 0.800049L1.41992 6.90005V19.08L11.9699 25.18L22.5299 19.08V6.90005Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 6.91992H16.9797C17.7097 6.91992 18.3097 7.50992 18.3097 8.24992V21.1599H14.6797V6.91992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66016 21.1499H6.03015L6.03015 8.2399C6.03015 7.5099 6.62017 6.9099 7.36017 6.9099H9.66016L9.66016 21.1499Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1696 3.6499H3.97964C3.23964 3.6499 2.63965 4.2499 2.63965 4.9899V21.5099H21.5096V4.9899C21.5096 4.2499 20.9096 3.6499 20.1696 3.6499ZM19.4096 21.1599H4.93964V8.2499C4.93964 7.5199 5.52962 6.9199 6.26962 6.9199H18.0896C18.8196 6.9199 19.4196 7.5099 19.4196 8.2499V21.1599H19.4096Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7803 6.91992H18.0803C18.8103 6.91992 19.4103 7.50992 19.4103 8.24992V21.1599H15.7803V6.91992Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55957 21.1499H4.92957L4.92957 8.2399C4.92957 7.5099 5.51958 6.9099 6.25958 6.9099H8.55957L8.55957 21.1499Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980469 21.51C0.980469 21.51 24.0105 21.51 23.5105 21.51H0.980469Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980469 21.51C0.980469 21.51 24.0105 21.51 23.5105 21.51",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49023 5.73999L10.4902 4.73999L11.5002 5.73999",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49023 5.73999L10.4902 4.73999L11.5002 5.73999",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.73999L13.5 5.73999L12.5 4.73999",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.73999L13.5 5.73999L12.5 4.73999",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.f3d09647.svg";
export { ForwardRef as ReactComponent };